var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 16C5.86508 16 3.85611 15.1678 2.34508 13.6569C0.834109 12.1458 0.00195312 10.1369 0.00195312 8C0.00195312 5.86312 0.834109 3.85416 2.34508 2.34313C3.85611 0.832156 5.86508 0 8.00195 0C10.1388 0 12.1478 0.832156 13.6588 2.34313C15.1698 3.85416 16.002 5.86312 16.002 8C16.002 10.1369 15.1698 12.1458 13.6588 13.6569C12.1478 15.1678 10.1388 16 8.00195 16ZM8.00195 1.25C4.27998 1.25 1.25195 4.27803 1.25195 8C1.25195 11.722 4.27998 14.75 8.00195 14.75C11.7239 14.75 14.752 11.722 14.752 8C14.752 4.27803 11.7239 1.25 8.00195 1.25ZM10.8242 10.8726C11.0683 10.6285 11.0683 10.2328 10.8242 9.98875C10.5801 9.74466 10.1844 9.74469 9.94036 9.98875C8.84373 11.0853 7.05948 11.0854 5.96286 9.98875C5.43167 9.45753 5.13911 8.75125 5.13911 8C5.13911 7.24875 5.43167 6.54247 5.96286 6.01125C7.05948 4.91463 8.84373 4.91469 9.94036 6.01125C10.1845 6.25534 10.5802 6.25534 10.8242 6.01125C11.0683 5.76716 11.0683 5.37144 10.8242 5.12738C9.24023 3.54341 6.66292 3.54344 5.07898 5.12738C4.31164 5.89469 3.88908 6.91488 3.88908 8C3.88908 9.08512 4.31164 10.1053 5.07898 10.8726C5.87095 11.6646 6.91127 12.0606 7.95161 12.0606C8.99195 12.0606 10.0323 11.6646 10.8242 10.8726Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.67142f00bb8c2ba08a28586da6322473.svg";
export { ForwardRef as ReactComponent };